import { render } from "./AtuComponentsRenderer.vue?vue&type=template&id=b67d7eee"
import script from "./AtuComponentsRenderer.vue?vue&type=script&lang=js"
export * from "./AtuComponentsRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__